import { ApiInstance } from '..';
import { convert2QueryString } from '../../utils/convert2QueryString';
import { TInvoiceRequest } from './type';

export const getInvoice = (payload: TInvoiceRequest) => {
    const requestURL = '/api/invoice?' + convert2QueryString(payload);
    return ApiInstance.getInstance().get(requestURL);
};

export const exportInvoices = (params: string[]) => {
    const requestURL = '/api/invoice';
    const payload = {
        invoice_no: params,
    };
    return ApiInstance.getInstance().post(requestURL, payload);
};

export const getAllInvoice = (payload: TInvoiceRequest) => {
    const requestURL =
        '/api/invoice?is_full=true&' + convert2QueryString(payload);
    return ApiInstance.getInstance().get(requestURL);
};

export const getInvoiceDetails = (id: string) => {
    const requestURL = `/api/invoice/${id}`;
    return ApiInstance.getInstance().get(requestURL);
};

export const submitInvoice = (id: string) => {
    const requestURL = `/api/invoice/${id}/submit`;
    return ApiInstance.getInstance().post(requestURL, {});
};
